import React, { useEffect } from 'react';
import { getProfile } from '../app/api';
import { useUserContext } from '../context/UserContext';
import { Avatar, Dropdown, Space, Menu } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';

const Header = () => {
  const { profile, setProfile } = useUserContext();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getProfile();
        if (response?.data?.success) {
          setProfile(response?.data?.user);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
    // eslint-disable-next-line
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login'
    setProfile(null);
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <header style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-end',
      background: '#001529', 
      padding: '0 20px',
      height: '60px'
    }}>
      <Dropdown overlay={userMenu} trigger={['hover']}>
        <Space style={{ cursor: 'pointer', color: 'white' }}>
          <Avatar icon={<UserOutlined />} />
          <span>{profile?.firstName} {profile?.lastName}</span>
        </Space>
      </Dropdown>
    </header>
  );
};

export default Header;
